export default __webpack_public_path__ + "static/media/user_circle.42a25ee2.svg";